import type { INode } from '../../../shared/components/filter-bar/models/filter.model';

export const DEFAULT_SERVICE_DEPARTMENTS: INode[] = [
  { key: 'Anesthesiology', label: 'Anesthesiology', value: 'a1b2c3d4-0001-4000-8000-000000000001' },
  { key: 'Cardiology', label: 'Cardiology', value: 'a1b2c3d4-0001-4000-8000-000000000002' },
  { key: 'Emergency Medicine', label: 'Emergency Medicine', value: 'a1b2c3d4-0001-4000-8000-000000000003' },
  { key: 'General Surgery', label: 'General Surgery', value: 'a1b2c3d4-0001-4000-8000-000000000004' },
  { key: 'Internal Medicine', label: 'Internal Medicine', value: 'a1b2c3d4-0001-4000-8000-000000000005' },
  { key: 'Neurology', label: 'Neurology', value: 'a1b2c3d4-0001-4000-8000-000000000006' },
  { key: 'Obstetrics & Gynecology', label: 'Obstetrics & Gynecology', value: 'a1b2c3d4-0001-4000-8000-000000000007' },
  { key: 'Oncology', label: 'Oncology', value: 'a1b2c3d4-0001-4000-8000-000000000008' },
  { key: 'Orthopedics', label: 'Orthopedics', value: 'a1b2c3d4-0001-4000-8000-000000000009' },
  { key: 'Pediatrics', label: 'Pediatrics', value: 'a1b2c3d4-0001-4000-8000-000000000010' },
  { key: 'Pharmacy', label: 'Pharmacy', value: 'a1b2c3d4-0001-4000-8000-000000000011' },
  { key: 'Psychiatry', label: 'Psychiatry', value: 'a1b2c3d4-0001-4000-8000-000000000012' },
  { key: 'Pulmonology', label: 'Pulmonology', value: 'a1b2c3d4-0001-4000-8000-000000000013' },
  { key: 'Radiology', label: 'Radiology', value: 'a1b2c3d4-0001-4000-8000-000000000014' },
  { key: 'Rehabilitation', label: 'Rehabilitation', value: 'a1b2c3d4-0001-4000-8000-000000000015' },
];
